<template>
  <div>
    <basic-container class = "config-list-container">
      <avue-crud ref="crud"
                 :option="tableOption"
                 :data="tableData"
                 :page="page"
                 :table-loading="tableLoading"
                 :before-open="handleOpenBefore"
                 @refresh-change="getList"
                 @current-change="handleCurrentChange"
                 @size-change="handleSizeChange">

        <template slot="menuLeft">
          <el-button type="primary" @click="handleAdd" icon="el-icon-plus" size="small" v-if="permissions.app_config_add">新增内容</el-button>
        </template>
         <template slot-scope="scope"
                  slot="menu">
          <el-button type="text"
                     v-if="permissions.app_config_edit"
                     icon="el-icon-edit"
                     size="mini"
                     @click="handleUpdate(scope.row,scope.index)">编辑</el-button>
          <el-button type="text"
                     v-if="permissions.app_config_del"
                     icon="el-icon-delete"
                     size="mini"
                     title="删除"
                     @click="handleDelete(scope.row,scope.index)">删除</el-button>
        </template>
      </avue-crud>
    </basic-container>
    <el-dialog
      :title="title"
      :visible.sync="addDialogVisible"
      @close="cancel()"
      width="30%">
      <template>
        <el-form ref="groupInfo" class="groupInfo" :model="groupInfo" label-width="100px" size="medium" :rules="rules">
          <el-row gutter="20">
            <el-form-item label="分组名" prop="groupName">
              <el-input v-model="groupInfo.groupName" placeholder="请输入分组名"></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input-number style="width: 100%" :precision="0" v-model="groupInfo.sort" controls-position="right" @change="handleChange" :min="0"></el-input-number>
            </el-form-item>
          </el-row>
        </el-form>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel()">取 消</el-button>
        <el-button type="primary" @click="handleSubmit()">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { createAppGroup,  removeAppGroup, editAppGroup, getAppGroupInfo, getAppGroupDrop } from '@/api/app/config'
  import {listTableOption} from '@/const/crud/app/group'
  import {mapGetters} from "vuex";
  export default {
    name: "table_app_group",
    data() {
      return {
        tableOption: listTableOption,
        groupInfo:{
          groupName: '',
          sort: ''
        },
        title: '新增',
        isEdit: false,
        id: '',

        tableData:[],
        addDialogVisible: false,
        tableLoading: false,
        rules: {
          groupName: [
            { type: 'string', required: true, message: '请输入分组名', trigger: 'blur' },
            { max: 50, message: '不超过50个', trigger: 'blur' }
          ],
          sort: [
            { type: 'number', required: true, message: '请输入排序', trigger: 'blur' },
          ]
        }
      };
    },
    created() {
      this.getList();
    },
    computed: {
      ...mapGetters(['permissions']),
    },
    activated() {
      this.getList();
    },
    methods: {
      getList() { 
        this.tableLoading = true
        getAppGroupDrop().then(response => {
          this.tableData = response.data.data;
          this.tableLoading = false
        })
      },
      initPage() {
        this.page.currentPage = 1
        this.page.pageSize = this.search.size
        this.search.current = 1
      },

      handleOpenBefore(show, type) {
        show();
      },
      handleAdd() {
        this.addDialogVisible = true;
      },
      handleUpdate(row) {
        this.title = '编辑';
        this.isEdit = true;
        getAppGroupInfo(row.id).then(res => {
          this.groupInfo = res.data.data
          this.addDialogVisible = true;
        }).catch(error => {
          this.$message({
            message: '获取详情失败',
            type: 'error'
          })
        })
        this.id = row.id;
      },
      handleSubmit() {
        const params = this.groupInfo
        this.$refs['groupInfo'].validate((valid) => {
          if (valid) {
            if (!this.isEdit){
              createAppGroup(params).then(res => {
              if (res.data.code === 0) {
                this.$message({
                  message: '创建成功',
                  type: 'success'
                })
                this.$router.$avueRouter.closeTag()
                this.getList()
                this.addDialogVisible = false;
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'error'
                })
              }
            }).catch(err => {
              this.$message({
                message: err,
                type: 'error'
              })
            })
            } else { 
              params.id = this.id;
              editAppGroup(params).then(res => {
                if (res.data.code === 0) {
                  this.$message({
                    message: '编辑成功',
                    type: 'success'
                  })
                  this.$router.$avueRouter.closeTag()
                  this.getList()
                  this.addDialogVisible = false;
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: 'error'
                  })
                }
              }).catch(err => {
                this.$message({
                  message: err,
                  type: 'error'
                })
              })
            }
          } else {
            this.$message({
              message: '请通过验证',
              type: 'error'
            })
            return false;
          }
        });
      },
      cancel () {
        this.$refs['groupInfo'].clearValidate();
        this.addDialogVisible = false;
        this.groupInfo.groupName = '';
        this.groupInfo.sort = 0
      },
      handleDelete(row) {
        this.$confirm('确定要删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          removeAppGroup(row.id).then(response => {
            if (response.data.data) {
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              this.getList()
            }
          }).catch(error => {
            this.$message({
              message: error,
              type: 'error'
            })
          })
        })
      },
    }
  };

</script>


<style lang="scss" scoped>

.config-list {
  padding-left: 22px;
  background: #fff;
  &-filter {
    margin: 0px 10px;
    background-color: #fff;
    padding-top: 20px;
    padding-left: 22px;

    &-label {
      font-size: 14px;
      color: #606266;
      margin-right: 10px;
    }

    &-value {
      width: 96%!important;
    }

    &-date {
      width: 96%!important;
    }

    &-reset {
      float: right;
      margin-right: 8px;
    }

    &-search {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }

  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
    }
  }
  .clamp-text {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
}
/deep/.el-dialog__body {
  padding : 10px 20px 10px 20px;
}
/deep/.el-input-number {
  line-height: 36px;
}
.groupInfo{
  padding-right: 50px;
}
.down-dialog-item-label {
  display: inline-block;
  margin: 10px 0;
}
</style>
